module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero_wrapper Custom-Slider"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 Custom-Slider-form"
  }, [_c('book-online')], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "Custom-Slider-title"
  }, [_vm._v("Bienvenidos a "), _c('span', {
    attrs: {
      "id": "text_rotating"
    }
  }, [_vm._v("Hotel CEO Group")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "Custom-Slider-rating"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-star-o"
  })]), _vm._v(" "), _c('li', {
    staticClass: "Custom-Slider-rating-text"
  }, [_vm._v("Su mejor opción de hospedaje en Campeche")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "Custom-Slider-list"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" Habitaciones modernas y cómodas")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" Excelente ubicación cercano al malecón de la Ciudad")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" Estacionamiento y alberca al aire libre")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "Custom-Slider-box"
  }, [_c('div', {
    staticClass: "row Custom-Slider-box-item"
  }, [_c('div', {
    staticClass: "col-md-2 Custom-Slider-box-item-icon"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 Custom-Slider-box-item-text",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("Wi-Fi")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "Custom-Slider-box"
  }, [_c('div', {
    staticClass: "row Custom-Slider-box-item"
  }, [_c('div', {
    staticClass: "col-md-2 Custom-Slider-box-item-icon"
  }, [_c('i', {
    staticClass: "fa fa-cutlery"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 Custom-Slider-box-item-text",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("Comedor")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "Custom-Slider-box"
  }, [_c('div', {
    staticClass: "row Custom-Slider-box-item"
  }, [_c('div', {
    staticClass: "col-md-2 Custom-Slider-box-item-icon"
  }, [_c('i', {
    staticClass: "fa fa-car"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 Custom-Slider-box-item-text",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("Estacionamiento")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-774c04e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/CustomSlider.vue
// module id = 382
// module chunks = 0